import gql from 'graphql-tag'

export const getPoliciesReport = gql`
  query($paging: PagingQuery, $order: PoliciesOrder, $filter: PoliciesFilter!) {
    getPoliciesReport(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      policies {
        id
        cancelDate
        policyName
        status
        effectiveDate
        expirationDate
        originalInceptionDate
        brokerFee
        agencyFee
        carrierPolicyFee
        inspectionFee
        taxesFee
        stampingFee
        premium
        policyNumber
        term
        type
        closed
        bindDate
        payerType
        nonRenew
        createdAt
        updatedAt
        productCommissionOverride
        additionalInfoStr
        billingType
        isPremiumPayOff
        isCommissionPayOff
        billingType
        totalProjectedCommission
        totalProjectedPremium
        totalPremiumReceived
        totalCommissionReceived
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        createdBy {
          id
          username
        }
        lastModifiedBy {
          id
          username
        }
        source {
          id
          name
        }
        book {
          id
          name
        }
        recordType {
          id
          name
        }
        account {
          id
          name
          producers {
            id
            username
          }
        }
        primaryContact {
          id
          name
        }
        payments {
          id
          amount
          receivedDate
          status
          notes
          createdAt
          updatedAt
        }
        commissions {
          id
          amount
          receivedDate
          status
          notes
          createdAt
          updatedAt
        }
        generalAgent {
          id
          name
        }
      }
      totalProjectedPremium
      totalCommissionReceived
      totalProjectedCommission
      paging{
        totalCount
        currentOffset
        currentLimit
      }
    }
  }
`

export const getPolicesExpiringInAMonth = gql`
  query($expirationStartDate: String,$order:PoliciesOrder){
    getPolicesExpiringInAMonth(
      expirationStartDate: $expirationStartDate,
      order:$order
    ){
      id
      policyName
      status
      effectiveDate
      expirationDate
      originalInceptionDate
      brokerFee
      agencyFee
      carrierPolicyFee
      inspectionFee
      taxesFee
      stampingFee
      premium
      policyNumber
      term
      type
      closed
      nonRenew
      createdAt
      updatedAt
      productCommissionOverride
      additionalInfoStr
      billingType
      isPremiumPayOff
      isCommissionPayOff
      billingType
      totalProjectedCommission
      totalProjectedPremium
      totalPremiumReceived
      totalCommissionReceived
      carrier {
        id
        name
      }
      carrierProduct {
        id
        name
      }
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
      source {
        id
        name
      }
      recordType {
        id
        name
      }
      account {
        id
        name
        producers {
          id
          username
        }
      }
      primaryContact {
        id
        name
      }
      payments {
        id
        amount
        receivedDate
        status
        notes
        createdAt
        updatedAt
      }
      commissions {
        id
        amount
        receivedDate
        status
        notes
        createdAt
        updatedAt
      }
      generalAgent {
        id
        name
      }
    }
  }
`

export const getPolicesExpiredLastMonth = gql`
  query($expirationEndDate: String,$order:PoliciesOrder){
    getPolicesExpiredLastMonth(
      expirationEndDate: $expirationEndDate,
      order: $order
    ){
      id
      policyName
      status
      effectiveDate
      expirationDate
      originalInceptionDate
      brokerFee
      agencyFee
      carrierPolicyFee
      inspectionFee
      taxesFee
      stampingFee
      premium
      policyNumber
      term
      type
      closed
      nonRenew
      createdAt
      updatedAt
      productCommissionOverride
      additionalInfoStr
      billingType
      isPremiumPayOff
      isCommissionPayOff
      billingType
      totalProjectedCommission
      totalProjectedPremium
      totalPremiumReceived
      totalCommissionReceived
      carrier {
        id
        name
      }
      carrierProduct {
        id
        name
      }
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
      source {
        id
        name
      }
      recordType {
        id
        name
      }
      account {
        id
        name
        producers {
          id
          username
        }
      }
      primaryContact {
        id
        name
      }
      payments {
        id
        amount
        receivedDate
        status
        notes
        createdAt
        updatedAt
      }
      commissions {
        id
        amount
        receivedDate
        status
        notes
        createdAt
        updatedAt
      }
      generalAgent {
        id
        name
      }
    }
  }
`

export const exportPolicyReports = gql`
  mutation($displayColumns: [String!], $exportType: ExportType!, $input: NewExportInput!) {
    exportPolicyReports(
      displayColumns: $displayColumns,
      exportType: $exportType,
      input: $input
    )
  }
`
